import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/utilities/auth.service';
import { UiPermissionsService } from '../services/utilities/ui-permissions.service';
import { PostService } from 'src/app/services/repositories/post.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private uiPermissionService: UiPermissionsService,
    private postService: PostService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    // temporarly redirect any /dashboard route to /dashboard/linkedin 
    // if (state.url.includes('/dashboard') && state.url !== '/dashboard/linkedin' && state.url !== '/dashboard/google') {
    //   console.log('👮‍♂️ Redirecting from:', state.url, 'to /dashboard/linkedin');
    //   // Return a UrlTree to redirect to /dashboard/linkedin
    //   return this.router.createUrlTree(['/dashboard/linkedin']);
    // }

    const mapName = route.data['mapName']; // Get the map name from route data
    const user = this.authService.loadUserfromLs();

    return this.uiPermissionService.getPermissions().pipe(
      map((uiMaps) => {
        if (user?.isAdmin) {
          const lsData = this.postService.getGroupScopesFromLocalStorage() || [];
          if (lsData.length > 0 || mapName == 'global.backoffice') {
            return true;
          } else {
            this.router.navigate(['/back-office']);
            return false;
          }
        }
        if (!user?.isAdmin && mapName == 'home') {
          return true;
        }
        for (let uiMap of uiMaps) {
          if (uiMap.name === mapName) {
            console.log(user.UI)
            const result = this.uiPermissionService.isActionsOnUserAccreditations(
              uiMap,
              user?.accreditations,
              user?.isAdmin
            );
            // console.log(`⚠️ Permission check for ${mapName}:`,result);
            if (result) {
              return true;
            }
          }
        }

        this.router.navigate(['/home']);
        return false;
      }),
      catchError((error) => {
        console.error('Error in permission check:', error);
        this.authService.logout()
        this.router.navigate(['/posts']);
        return of(false);
      })
    );
  }
}